<template>
  <el-row>
    <el-form ref="AccountFrom" :model="account" :rules="rules" label-position="left" label-width="0px" class="demo-ruleForm login-container">
      <h3 class="title">管理员登录</h3>
      <el-form-item prop="username">
        <el-input type="text" v-model="account.username" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input type="password" v-model="account.pwd" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <!--<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click.native.prevent="handleLogin" :loading="loading">登录</el-button>
      </el-form-item>
    </el-form>
    <div class="footer">
      <h5 style="color:#555;font-size:12px">所有方：一丝不苟</h5>
      <h6 style="color:#555;font-size:12px">Copyright © 2018 imooc.com All Rights Reserved | 京ICP备 12003892号-11</h6>
    </div>


    <el-dialog
      :visible.sync="dialogAddVisible"
      width="350px"
      :show-close="false"
      center
    >
      <div class="dialog-body" style="display: flex;align-items: center;justify-content: center;flex-direction: column">
        <div style="font-size: 20px;color: #505458;font-weight: bold;margin-bottom: 18px">请填写手机短信验证码</div>
        <div style="font-size: 16px;color: #999;font-weight: 400;margin-bottom: 12px">发送到手机号：{{ mapObj.tel }}</div>
        <div style="margin-bottom: 12px">
          <el-input style="height: 44px" placeholder="请输入验证码" v-model="mapObj.code">
            <template slot="append">
              <div style="cursor: pointer" @click="sendCode">{{ time == 60 ? '发送验证码' : time }}</div>
            </template>
          </el-input>
        </div>
        <div>
          <el-button
            @click="dialogAddVisible = false"
          >取 消</el-button>
          <el-button
            :loading='loading'
            type="primary"
            @click="loginSecond"
          >保 存</el-button>
        </div>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import API from "../api/api_user";
import { powers } from "../powers.js";
export default {
  name:'Login',
  data() {
    return {
      loading: false,
      account: {
        username: "",
        pwd: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" }
          //{ validator: validaePass }
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" }
          //{ validator: validaePass2 }
        ]
      },
      checked: true,
      dialogAddVisible: false,
      time: 60,
      mapObj: {
        telephone: "",
        token: "",
        username: "",
        tel: ""
      },
      isSendCode: false
    };
  },
  methods: {
    loginSecond () {
      let that = this;
      if (this.mapObj.code == "") {
        return
      }
      let loginParams = {
        phoneCode: this.mapObj.code,
        token: this.mapObj.token
      };
      API.loginSecond(loginParams)
        .then(
          function(result) {
            that.loading = false;
            if (result && result.key == 1000) {
              localStorage.removeItem('provinceList')
              if (result.result.map.loginType == 3)
              {
                that.$message.error({
                  showClose: true,
                  message: result.message || "账户没有权限",
                  duration: 2000
                });
                return;
              }
              localStorage.setItem("username", result.result.map.username);
              localStorage.setItem("api_token", result.result.map.token);
              localStorage.setItem("powers", JSON.stringify(result.result.map.powers));
              //区域负责人，把负责的身份放到缓存里面
              if (result.result.map.provinceList && result.result.map.provinceList != null && result.result.map.provinceList.length != 0)
              {
                var name = [];
                for (var i = 0; i < result.result.map.provinceList.length; i++)
                {
                  var one = JSON.parse(result.result.map.provinceList[i].provinceList);
                  for(var j=0;j<one.length;j++)
                  {
                    if (name.indexOf(one[j]) == -1)
                    {
                      name.push(one[j])
                    }
                  }
                }
                localStorage.setItem("provinceList", name.join(','));
                that.$router.push({ path: "/AreaDashboard" });
              }
              else {
                that.$router.push({ path: "/" });
              }
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    sendCode () {
      let that = this;
      if (this.time != 60) {
        return
      }
      if (this.isSendCode) return
      this.isSendCode = true
      let loginParams = {
        telephone: this.mapObj.telephone,
        token: this.mapObj.token
      };
      API.loginSendCode(loginParams)
        .then(
          function(result) {
            that.loading = false;
            that.isSendCode = false;
            if (result && result.key == 1000) {
              that.setTime()
              that.$message.success({
                showClose: true,
                message: "发送验证码成功",
                duration: 1500
              });
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.loading = false;
            that.isSendCode = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    setTime() {
      if (this.time == 0) {
        this.time = 60
        return
      }
      setTimeout(() => {
        this.time = this.time - 1
        this.setTime()
      },1000)
    },
    handleLogin() {
      let that = this;
      this.$refs.AccountFrom.validate(valid => {
        if (valid) {
          this.loading = true;
          let loginParams = {
            username: this.account.username,
            password: this.account.pwd,
            submit:'Login'
          };
          API.login(loginParams)
            .then(
              function(result) {
                that.loading = false;
                if (result && result.key == 1000) {
                  that.dialogAddVisible = true
                  let obj = result.result.map
                  let telephone = obj.telephone;
                  obj.tel = telephone.substring(0,3) +'****'+ telephone.substring(7);
                  that.mapObj = obj
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    }
  }
};
</script>
<style>
body {
  background: #dfe9fb;
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  display: none;
}
.dialog-body /deep/ .el-input__inner{
  height: 44px;
}
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 160px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  background: -ms-linear-gradient(top, #ace, #00c1de); /* IE 10 */
  background: -moz-linear-gradient(top, #ace, #00c1de); /*火狐*/
  background: -webkit-gradient(
    linear,
    0% 0%,
    0% 100%,
    from(#ace),
    to(#00c1de)
  ); /*谷歌*/
  background: -webkit-linear-gradient(
    top,
    #ace,
    #00c1de
  ); /*Safari5.1 Chrome 10+*/
  background: -o-linear-gradient(top, #ace, #00c1de); /*Opera 11.10+*/

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
}
.footer{
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 0px;
  background:#f5f5f5
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue